/**
 * @date: 3/17/22
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 *
 */

import React from "react";
import {Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis} from "recharts";
import Typography from "@mui/material/Typography";


export default function BasicBar(props) {
    const {data, width, height} = props;
    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Typography fontWeight='bold' color={'#777'} marginBottom={3}>
                Directory Contribution Validation Issue Counts
            </Typography>
            <BarChart
                width={width}
                height={height}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                }}
            >
                <CartesianGrid strokeDasharray="3 3"/>
                <XAxis dataKey="name"/>
                <YAxis/>
                <Tooltip/>
                <Legend/>
                <Bar dataKey="tolerated" fill="#ff9800"/>
                <Bar dataKey="untolerated" fill="rgb(255 99 34)"/>
            </BarChart>
        </div>
    );
}
